import * as yup from "yup";

const DEFAULT_CONDITION_VALUES = {
  columnName: "",
  columnValue: "",
  change: "",
  isSaved: false,
};

const NEW_WHAT_IF_INITIAL_VALUES = {
  conditionGroups: [DEFAULT_CONDITION_VALUES],
};

const NEW_WHAT_IF_VALIDATION_SCHEMA = yup.object().shape({
  conditionGroups: yup
    .array()
    .of(
      yup.object().shape({
        columnName: yup.object().required("Column name is required"),
        columnValue: yup.object().required("Column value is required"),
        change: yup.number().required("Change is required"),
      })
    )
    .required("Condition groups are required"),
});

const DEFAULT_LIMITS = {
  min: 0,
  max: 100,
  isDisabled: true,
};

const TARGET_RATES = {
  final_target_rate: 0.7885891719548077,
  initial_target_rate: 0.7964169381107492,
};

const DEFAULT_PAGE_NUMBER = 1;

const MINIMUM_PAGE_SIZE = 12;

const PAGE_SIZE_INCREMENT = 12;

const tempAdjustment = [
  {
    column_name: "Creatinine_Mass_volume_inUrineco",
    event_adjustments: [
      {
        id: 1,
        initial_probability: 0.1681996698785869,
        final_probability: 0.2881996698785869,
      },
    ],
  },
  {
    column_name: "Ureanitrogen_Mass_volume_inBlood",
    event_adjustments: [
      {
        id: 0,
        initial_probability: 0.09536545107144741,
        final_probability: 0.2153654510714474,
      },
    ],
  },
];

const VARIANTS = {
  initial: { opacity: 0, scale: 0.75 },
  animate: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 0 },
};

export {
  NEW_WHAT_IF_INITIAL_VALUES,
  NEW_WHAT_IF_VALIDATION_SCHEMA,
  DEFAULT_CONDITION_VALUES,
  DEFAULT_LIMITS,
  DEFAULT_PAGE_NUMBER,
  MINIMUM_PAGE_SIZE,
  PAGE_SIZE_INCREMENT,
  TARGET_RATES,
  tempAdjustment,
  VARIANTS,
};
